// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2d6dfdc0","628":"5f5aa933","763":"f0c19520","891":"842b57dd","908":"f8a0abb8","983":"fb535abd"}[chunkId] + ".chunk.js";
};